<app-base-modal
  [title]="unitEconomicsCalculationsResourceType.name"
  [showStateToggle]="isValid()"
>
  <div class="unit-economics-calculations-wrapper">
    @if (isLoading) {
      <app-loader/>
    }
    <mat-accordion [multi]="true">
      @for (data of unitEconomicsCalculationsData(); track $index) {
        <mat-expansion-panel [expanded]="data.id === 0">
          <mat-expansion-panel-header>
            <mat-panel-title>
              <app-unit-economics-calculations-title
                [data]="data"
                [isEditModeActive]="isEditModeActive"
                (handleDelete)="handleDelete($event, data.id, $index)"
              />
            </mat-panel-title>
          </mat-expansion-panel-header>
          <app-unit-economics-calculations-form
            [technicalParametersId]="technicalParametersId()"
            [unitEconomicData]="data"
            [unitEconomicFormGroup]="unitEconomicsCalculationFormGroups()[$index]"
            [noFirstData]="noFirstData()"
            [isEditModeActive]="isEditModeActive"
            (updateUnitEconomicData)="updateUnitEconomicData($event, $index)"
            (deleteUnitEconomicData)="deleteUnitEconomicData($index)"
            (setLoadingState)="setLoadingState($event)"
          />
          @if (data.id) {
            <div
              class="unit-economics-calculations-files"
              app-unit-economics-calculations-files
              [unitEconomicsCalculationId]="data.id"
              [isEditModeActive]="isEditModeActive"
              (setLoadingState)="setLoadingState($event)"
            ></div>
          }
        </mat-expansion-panel>
      }
    </mat-accordion>
  </div>
  <div class="buttons-container">
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
    <button
      mat-button
      color="primary"
      type="button"
      [disabled]="!isValid()"
      (click)="handleAddNew()"
    >
      Добавить новый
    </button>
  </div>
</app-base-modal>
